import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SummaryComponent } from './summary.component';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
  ],
  declarations: [
    SummaryComponent,
  ],
  exports: [
    SummaryComponent,
  ],
})
export class SummaryModule { }
